import { CustomizeCardSheet } from '../../../components/cv/CustomizeCardSheet';

export default function CustomizeCardScreen() {
  return <CustomizeCardSheet />;
}
